/* KIMLOO — przebudowa */
(function () {
  if (window.__kn) return;
  window.__kn = true;

  function $$(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'PLN';
    try { return new Intl.NumberFormat('pl-PL', { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2).replace('.', ',') + ' zł'; }
  }
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initGallery(root) {
    var track = root.querySelector('[data-kn-track]');
    if (!track) return null;
    var slides = $$(track, '[data-kn-slide]');
    var thumbs = $$(root, '[data-kn-thumb]');
    var prev = root.querySelector('[data-kn-prev]');
    var next = root.querySelector('[data-kn-next]');
    var cur = 0;
    function mark(i) {
      cur = i;
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= slides.length - 1;
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }
    function go(i) {
      if (i < 0 || i >= slides.length) return;
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      mark(i);
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    if (prev) prev.addEventListener('click', function () { go(cur - 1); });
    if (next) next.addEventListener('click', function () { go(cur + 1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); }
    });
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { mark(Math.round(track.scrollLeft / track.clientWidth)); });
    }, { passive: true });
    return { go: go };
  }

  function initBuy(root) {
    if (root.dataset.knReady) return;
    root.dataset.knReady = '1';
    var jsonEl = root.querySelector('[data-kn-json]');
    if (!jsonEl) return;
    var data = JSON.parse(jsonEl.textContent);
    var gallery = initGallery(root);
    var form = root.querySelector('form[action*="/cart/add"]');
    var idInput = form.querySelector('[name="id"]');
    var prop = form.querySelector('[data-kn-prop]');
    var addBtn = form.querySelector('[data-kn-add]');
    var addText = form.querySelector('[data-kn-add-text]');
    var err = form.querySelector('[data-kn-error]');
    var packs = $$(root, '[data-kn-pack]');
    var rows = $$(root, '[data-kn-color-row]');
    var ship = root.querySelector('[data-kn-ship]');
    var sticky = root.querySelector('[data-kn-sticky]');

    function checked(scope, sel) { var c = scope.querySelector(sel + ':checked'); return c ? c.value : null; }
    function findVariant(pack, color) {
      for (var i = 0; i < data.variants.length; i++) {
        var v = data.variants[i];
        if (v.o[data.packIndex] !== pack) continue;
        if (data.colorIndex >= 0 && v.o[data.colorIndex] !== color) continue;
        return v;
      }
      return null;
    }
    function showColorMedia(color) {
      if (!gallery || !color) return;
      var stem = color.toLowerCase().slice(0, 4);
      for (var i = 0; i < data.media.length; i++) {
        if ((data.media[i].alt || '').indexOf(stem) !== -1) { gallery.go(i); return; }
      }
    }

    function update(changedColorRow) {
      var packInput = root.querySelector('[data-kn-pack]:checked') || packs[0];
      var pack = packInput.value;
      var n = parseInt(packInput.dataset.n, 10) || 1;
      var colors = [];
      rows.forEach(function (row, i) {
        row.hidden = i >= n;
        var label = row.querySelector('[data-kn-row-label]');
        if (label) label.textContent = n === 1 ? 'Kolor' : 'Poduszka ' + (i + 1);
        var val = checked(row, '[data-kn-color]');
        var out = row.querySelector('[data-kn-color-name]');
        if (out) out.textContent = val || '';
        if (i < n) colors.push(val);
      });
      var v = findVariant(pack, colors[0]);
      if (!v) { addBtn.disabled = true; addText.textContent = 'Niedostępne'; return; }
      idInput.value = v.id;
      addBtn.disabled = !v.a;
      addText.textContent = v.a ? data.addLabel + ' · ' + money(v.p) : 'Wyprzedane';

      prop.disabled = n < 2;
      prop.value = n > 1 ? colors.join(', ') : '';

      if (ship) {
        var free = data.freeFrom > 0 && v.p >= data.freeFrom;
        ship.classList.toggle('is-free', free);
        ship.querySelector('[data-kn-ship-text]').textContent = free ? ship.dataset.free : ship.dataset.paid;
      }
      if (sticky) {
        sticky.querySelector('[data-kn-sticky-price]').textContent = money(v.p);
        sticky.querySelector('[data-kn-sticky-pack]').textContent = pack;
      }
      if (changedColorRow === 0) showColorMedia(colors[0]);
    }

    packs.forEach(function (p) { p.addEventListener('change', function () { update(-1); }); });
    rows.forEach(function (row, i) {
      $$(row, '[data-kn-color]').forEach(function (inp) { inp.addEventListener('change', function () { update(i); }); });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (addBtn.disabled) return;
      addBtn.classList.add('is-loading');
      err.hidden = true;
      var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(base + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (x) {
          if (x.ok) { window.location.href = base + 'cart'; return; }
          err.textContent = x.j.description || x.j.message || 'Nie udało się dodać do koszyka. Spróbuj jeszcze raz.';
          err.hidden = false;
          addBtn.classList.remove('is-loading');
        })
        .catch(function () { form.submit(); });
    });

    if (sticky) {
      var sb = sticky.querySelector('[data-kn-sticky-add]');
      sb.addEventListener('click', function () { addBtn.click(); });
      if ('IntersectionObserver' in window) {
        var footerSeen = false, btnSeen = true;
        var set = function () {
          var on = !btnSeen && !footerSeen;
          sticky.classList.toggle('is-on', on);
          sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
          sb.tabIndex = on ? 0 : -1;
        };
        new IntersectionObserver(function (es) { btnSeen = es[0].isIntersecting || es[0].boundingClientRect.top > 0; set(); }).observe(addBtn);
        var foot = document.querySelector('footer, .kn-final');
        if (foot) new IntersectionObserver(function (es) { footerSeen = es[0].isIntersecting; set(); }).observe(foot);
      }
    }

    update(-1);
  }

  function initLog(list) {
    if (list.dataset.knReady) return;
    list.dataset.knReady = '1';
    var items = $$(list, 'li');
    if (reduce || !('IntersectionObserver' in window)) { items.forEach(function (li) { li.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -35% 0px' });
    items.forEach(function (li) { io.observe(li); });
  }

  // Animacja napisów i zdjęcia: przewijanie -> postęp p, wygładzany co klatkę.
  // Horizon na komputerze przewija .page-wrapper zamiast okna, więc szukamy prawdziwego kontenera przewijania.
  function scrollerOf(el) {
    for (var n = el.parentElement; n && n !== document.body && n !== document.documentElement; n = n.parentElement) {
      var oy = getComputedStyle(n).overflowY;
      if ((oy === 'auto' || oy === 'scroll') && n.scrollHeight > n.clientHeight + 1) return n;
    }
    return null;
  }
  function initUnfold(el) {
    if (el.dataset.knReady) return;
    el.dataset.knReady = '1';
    function clamp(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }
    function seg(p, a, b) { return clamp((p - a) / (b - a)); }
    function inOut(x) { return x < .5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2; }
    function out(x) { return 1 - Math.pow(1 - x, 3); }
    function render(p) {
      var st = el.style;
      st.setProperty('--p', p.toFixed(4));
      st.setProperty('--e', inOut(seg(p, .04, .56)).toFixed(4));
      st.setProperty('--c', out(seg(p, .6, .82)).toFixed(4));
    }
    if (reduce) { render(1); return; }
    var sc = scrollerOf(el);
    var cur = 0, target = 0, raf = 0;
    function measure() {
      var r = el.getBoundingClientRect();
      var top0 = sc ? sc.getBoundingClientRect().top : 0;
      var vh = sc ? sc.clientHeight : window.innerHeight;
      var span = r.height - vh;
      target = span > 0 ? clamp((top0 - r.top) / span) : 1;
    }
    function tick() {
      cur += (target - cur) * 0.16;
      if (Math.abs(target - cur) < 0.0005) { cur = target; raf = 0; } else { raf = requestAnimationFrame(tick); }
      render(cur);
    }
    function onScroll() { measure(); if (!raf) raf = requestAnimationFrame(tick); }
    if (sc) sc.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { sc = scrollerOf(el) || sc; onScroll(); });
    measure(); cur = target; render(cur);
  }

  function init(scope) {
    var s = scope || document;
    $$(s, '[data-kn-buy]').forEach(initBuy);
    $$(s, '[data-kn-log]').forEach(initLog);
    $$(s, '[data-kn-unfold]').forEach(initUnfold);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
